import createWsAction from 'utils/create-ws-action'

// ------------------------------------
// Action Types
// ------------------------------------

export const DOORFLOW_CLIENT_CONFIG_GET_FETCH = 'unifi.DOORFLOW_CLIENT_CONFIG_GET_FETCH'
export const DOORFLOW_CLIENT_CONFIG_UPDATE = 'unifi.DOORFLOW_CLIENT_CONFIG_UPDATE'

// ------------------------------------
// Action Creators
// ------------------------------------


export const getClientConfig = createWsAction({
  type: DOORFLOW_CLIENT_CONFIG_GET_FETCH,
  messageType: 'doorflow.client.get-doorflow-client-config',
  selectorKey: 'doorflowClientConfigDetail',
  fields: ['clientId']
})

export const updateClientConfig = createWsAction({
  type: DOORFLOW_CLIENT_CONFIG_UPDATE,
  messageType: 'doorflow.client.edit-doorflow-client-config',
  selectorKey: 'doorflowClientConfigDetail',
  fields: ['clientId', 'changes']
})

export default null



// WEBPACK FOOTER //
// ./src/redux/modules/model/doorflow.js